/* eslint-disable */
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";

export interface IDate {
  year: number;
  month: number;
  day: number;
}

export function concatZeroToNumber(num: number | string) {
  return Number(num) < 10 ? "0" + num : num.toString();
}

export const dateToString = (date: IDate | any): string | null => {
  if (!date) return null;
  const newDate = { year: "", month: "", day: "" };

  newDate.day = concatZeroToNumber(date?.day);
  newDate.month = concatZeroToNumber(date?.month);
  newDate.year = date?.year.toString();

  return new Date(`${newDate?.year}-${newDate?.month}-${newDate?.day}`)
    .toISOString()
    .split("T")[0];
};

export const dateToStringISOStringForTo = (date: IDate | any) => {
  const newDate = { year: "", month: "", day: "" };

  newDate.day = concatZeroToNumber(date?.day);
  newDate.month = concatZeroToNumber(date?.month);
  newDate.year = date?.year.toString();

  return `${newDate?.year}-${newDate?.month}-${newDate?.day}T23:59:59`;
};

export const dateToStringISOStringForFrom = (date: IDate | any) => {
  if (!date) return null;
  const checkedDate = typeof date == "string" ? new Date(date) : date;

  if (typeof date == "string") {
    checkedDate.day = checkedDate.getDay();
    checkedDate.month = checkedDate.getMonth();
    checkedDate.year = checkedDate.getFullYear();
  }

  const newDate = { year: "", month: "", day: "" };

  newDate.day = concatZeroToNumber(date?.day);
  newDate.month = concatZeroToNumber(date?.month);
  newDate.year = date?.year.toString();

  return `${newDate?.year}-${newDate?.month}-${newDate?.day}T00:00:00`;
};

export const fromDateToTimeZoneDate = (date: Date | any) => {
  if (!date) return null;

  return `${date.getFullYear()}-${concatZeroToNumber(
    date.getMonth() + 1
  )}-${date.getDate()}T00:00:00`;
};

export const DateToISOStringWithCurrentTimeZone = (date: string) => {
  const convertedToDate = new Date(date);
  const currentDate = new Date();

  const day = concatZeroToNumber(convertedToDate.getDate());
  const month = concatZeroToNumber(convertedToDate.getMonth() + 1);
  const year = convertedToDate.getFullYear();

  const hour = concatZeroToNumber(currentDate.getHours());
  const minute = concatZeroToNumber(currentDate.getMinutes());
  const seconds = concatZeroToNumber(currentDate.getSeconds());

  return `${year}-${month}-${day}`;
};

export const stringToDate = (text: Date | string): any => {
  if (text == null) return null;

  text = new Date(text);
  return {
    year: text.getFullYear(),
    month: text.getMonth() + 1,
    day: text.getDate(),
  };
};

export const dateToStringFormat = (
  date: Date,
  type: "date" | "month" | "year" = "date",
  isConcatZero = false
) => {
  if (date == null) return null;

  switch (type) {
    case "date":
      return `${date.getFullYear()}-${concatZeroToNumber(date.getMonth() + 1)}-${concatZeroToNumber(date.getDate())}`;
    case "month":
      return `${isConcatZero ? concatZeroToNumber(date.getMonth() + 1) : date.getMonth() + 1}.${date.getFullYear()}`;
    case "year":
      return date.getFullYear().toString();
  }
};

export const stringToDateFormat = (text: string | null) => {
  if (text == null) return null;
  if (text.includes(".")) {
    let [day, month, year] = text.split(".");
    day = concatZeroToNumber(day);
    month = concatZeroToNumber(month);
    text = `${year}-${month}-${day}`;
  }

  return new Date(text) as Date | null;
};

export const getYMD = (data: Date | null) => {
  if (!data) return null;

  const day = data.getDate();
  const month = data.getMonth() + 1;
  const year = data.getFullYear();

  return new NgbDate(year, month, day);
};

export function getCurrentWeekDates(): string[] {
  const today = new Date();
  const firstDayOfWeek = today.getDate() - today.getDay() + 1; // Monday as the start of the week

  const dates: string[] = [];
  for (let i = 0; i < 7; i++) {
    const date = new Date(today);
    date.setDate(firstDayOfWeek + i);
    dates.push(date.toISOString().split("T")[0]); // Format: YYYY-MM-DD
  }

  return dates;
}

export function checkContractEnd(
  contractEndDate: Date | string | null
): boolean {
  if (!contractEndDate) return false;

  const today = new Date();
  const getContractEndDate = new Date(contractEndDate);
  const oneMonthAhead = new Date(today);
  oneMonthAhead.setMonth(today.getMonth() + 1); // One month from today

  // Check if the contract end date is within the next month but after today
  return getContractEndDate <= oneMonthAhead && getContractEndDate > today;
}

export function hasContractEnded(contractEndDate: string | Date): boolean {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Normalize today's date to 00:00

  const endDate = new Date(contractEndDate);
  endDate.setHours(0, 0, 0, 0); // Normalize end date

  return endDate < today;
}

export function formatToDateOnly(dateStr: string): string {
  const date = new Date(dateStr);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
